export { TechnicalUserRedirect } from './TechnicalUserRedirect';
